import * as React from 'react';

import { getUrl } from './utils';
import { FDealType } from '../../../../../JsonQuery';
import { DealType } from '../../../components/filters/DealType';
import { useDealType } from '../../../utils/useDealType';

export const DealTypeContainer: React.FC = () => {
  const dealType = useDealType();

  const handleChange = React.useCallback((dealType: FDealType) => {
    if (dealType === FDealType.RentDaily) {
      return;
    }

    window.location.href = getUrl(window.location.href, dealType);
  }, []);

  return <DealType value={dealType} onChange={handleChange} />;
};
